<template>
    <v-card>
        <v-card-title>{{ $t("traffic_license_add") }}</v-card-title>
        <v-card-subtitle></v-card-subtitle>
        <v-card-text>
            <TrafficLicenseForm ref="form" v-model="data" />
        </v-card-text>
        <v-card-actions>
            <v-btn
                color="primary"
                class="me-2"
                @click="onSubmit"
                :loading="loading"
            >
                {{ $t("submit") }}
            </v-btn>
            <v-btn text @click="onCancel">
                {{ $t("cancel_btn") }}
            </v-btn>
        </v-card-actions>
        <PAlert v-bind="alert" v-model="alert.display" />
    </v-card>
</template>
  
<script>
import TrafficLicenseForm from "./TrafficLicenseForm.vue";
import license from "../../services/license";
import PAlert from "../common/PAlert.vue";
import { v4 as uuid } from "uuid";

export default {
    components: {
        TrafficLicenseForm,
        PAlert,
    },
    props: {
        vehicleId: [Number, String],
    },
    data() {
        return {
            data: {},
            alert: {
                display: false,
                content: "Are you sure?",
                callback: null,
            },
            idempotentKey: null,
            loading: false,
        };
    },
    methods: {
        onSubmit() {
            this.alert = {
                ...this.alert,
                display: true,
                content: this.$t("are_you_sure_you_want_to_save"),
                callback: this.submit,
            };
        },
        submit() {
            if(!this.$refs.form.$refs.form.validate()) return;
            this.loading = true;
            license
                .create({...this.data, vehicle_id: Number(this.vehicleId), idempotentKey: this.idempotentKey})
                .then((res) => {
                    this.$emit("created", res.data);
                })
                .catch((error) => {
                    alert(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        onCancel() {
            this.alert = {
                ...this.alert,
                display: true,
                content: this.$t("are_you_sure_cancel"),
                callback: this.cancel,
            };
        },
        cancel() {
            this.$emit("cancel");
        },
    },
    created() {
        this.idempotentKey = uuid();
    },
};
</script>
  
  <style>
</style>